
 <a class="nav-link active " href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
 aria-haspopup="true" aria-expanded="false">
 {{user?.permissionLevel}} <img class="dropdown-arrow" src="/assets/images/iconmonstr-arrow-66.svg" alt=""
   srcset="">
</a>
<div class="modal-body">
  <ng-content></ng-content>
</div>
<div class="background-wrapper"></div>